module.exports = __webpack_public_path__ + "static/img/Concertos.f13797b.f13797b9.jpg";